export default "__VITE_ASSET__Zgf2rz3Y__"